import { useRef, useEffect } from 'react';

// TODO: Add a story for this hook
const useTimers = () => {
  const timeoutsRef = useRef(new Set());
  const setAutoClearTimeout = (callback, timeout) => {
    const timer = window.setTimeout(() => {
      timeoutsRef.current.delete(timer);
      return callback();
    }, timeout);
    timeoutsRef.current.add(timer);
  };
  useEffect(() => {
    return () => {
      // Related issue: https://github.com/facebook/react/issues/15841
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timeoutsRef.current.forEach(timer => {
        window.clearTimeout(timer);
      });
    };
  }, []);
  return {
    setAutoClearTimeout
  };
};
var useTimers$1 = useTimers;

export { useTimers$1 as default };
//# sourceMappingURL=index.js.map
